import { useEffect, useState } from 'react';

type UseEmbedResizeOptions = {
  messageType?: string;
  minHeight?: number;
};

export function useEmbedResize(embedOrigin: string, options?: UseEmbedResizeOptions) {
  const messageType = options?.messageType ?? 'weive-form-resize';
  const minHeight = options?.minHeight ?? 760;
  const [height, setHeight] = useState(minHeight);

  useEffect(() => {
    const allowedOrigin = new URL(embedOrigin).origin;

    function onMessage(event: MessageEvent) {
      if (event.origin !== allowedOrigin) return;
      const data = event.data as { type?: string; height?: number } | null;
      if (data?.type !== messageType || typeof data.height !== 'number') return;
      const nextHeight = Math.ceil(data.height);
      setHeight(Math.max(minHeight, nextHeight));
    }

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [embedOrigin, messageType, minHeight]);

  return height;
}
